import React from 'react'
import DisplayHtml from 'src/components/Forms/RichTextEditor/DisplayHtml'
import { usePositionNotesById } from 'src/queries'

interface BodyProps {
  id: number
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const position = usePositionNotesById(id)
  return (
    <DisplayHtml value={position?.notes ?? ''} />
  )
}

export default Body
